<template>
  <div class="">
    <nav class="navbar navbar-expand-lg bg-body-tertiary">
      <div class="container-fluid" id="navigationBar">
        <router-link class="navbar-brand d-lg-none ps-2" to="/">
          <img :src="require('@/assets/images/layout/logo.svg')" style="width: 95px" alt="Amazing Mexico" />
        </router-link>
        <div id="hamburger-1" class="hamburger toggler border-0 d-lg-none" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown" aria-controls="navbarNav" aria-expanded="false"
          aria-label="Toggle navigation">
          <span class="line"></span>
          <span class="line"></span>
        </div>
        <div class="collapse navbar-collapse justify-content-center" id="navbarNavDropdown">
          <router-link class="navbar-brand d-none d-lg-block" to="/">
            <img :src="require('@/assets/images/layout/logo.svg')" style="width: 95px" alt="Amazing Mexico" />
          </router-link>
          <ul class="navbar-nav text-center border-bottom">
            <a class="dropdown-toggle nav-link border-bottom" href="#" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              Vacation Packages
            </a>
            <ul class="dropdown-menu border border-0">
              <li v-for="destination in destinations" :key="destination.name">
                <router-link class="dropdown-item text-center" :to="{
                  name: 'Destination',
                  params: { slug: destination.slug },
                }">
                  {{ destination.name }}
                </router-link>
              </li>
            </ul>
            <li class="nav-item text-center border-bottom">
              <a class="nav-link" href="https://blog.amazing-mexico.com">Blog</a>
            </li>
            <li class="nav-item text-center border-bottom">
              <router-link class="nav-link" to="/faq">FAQs</router-link>
            </li>
            <li class="nav-item fw-bold text-center border-bottom">
              <a class="nav-link" data-bs-toggle="modal" data-bs-target="#quoteRequestModal">
                Request a Quote
              </a>
            </li>
            <li class="nav-item fw-bold text-center border-bottom">
              <a class="nav-link" data-bs-toggle="modal" data-bs-target="#redeemPackageModal">
                Redeem My Package
              </a>
            </li>
          </ul>
          <span class="navbar-text lh-1 text-end d-none d-lg-block d-flex">
            <a :href="'tel:+1' + phone">
              <small class="text-dark-green">ANY DOUBT? CALL TOLL FREE</small>
              <span class="fw-bolder fs-2 d-block text-green">{{
                phone
              }}</span>
            </a>
          </span>
        </div>
      </div>
    </nav>
    <!-- Modal -->
    <div class="modal fade" id="quoteRequestModal" tabindex="-1" aria-labelledby="quoteRequestModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header pb-1">
            <h3 class="modal-title oh-golds text-dark-green" id="quoteRequestModalLabel">
              Request a Quote
            </h3>
            <button type="button" class="btn-close mb-2" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <quote-request />
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="redeemPackageModal" tabindex="-1" aria-labelledby="quoteRequestModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header pb-1">
            <h3 class="modal-title oh-golds text-dark-green" id="quoteRequestModalLabel">
              Redeem My Package
            </h3>
            <button type="button" class="btn-close mb-2" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <RedeemMyPackage />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store.js";
import QuoteRequest from "@/components/QuoteRequest.vue";
import RedeemMyPackage from "@/components/RedeemMyPackage.vue";

export default {
  data() {
    return {
      destinations: store.destinations.filter(d => d.visible !== false),
      phone: store.website.phone,
      end: new Date("2022-11-06T00:00:00")
    };
  },
  components: {
    QuoteRequest,
    RedeemMyPackage
  },
  methods: {
    
  }
}
</script>

<style>
/* .container-fluid {
  padding: 0px!important;
} */
#navigationBar {
  padding: 0px !important;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #02c0d1 !important;
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
    left: 585px;
    top: 82px;
    border: 0px;
    background-color: white !important;
  }
}


#navbarNavDropdown {
  z-index: 5;
  background-color: white;
}


.hamburger .line {
  width: 39pt;
  height: 3pt;
  background-color: black;
  display: block;
  margin: 7px auto;
  -webkit-transition: all 0.1s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.hamburger:hover {
  cursor: pointer;
}

/* ONE */

#hamburger-1[aria-expanded="true"] .line:nth-child(3) {
  opacity: 0;
}

#hamburger-1[aria-expanded="true"] .line:nth-child(1) {
  -webkit-transform: translateY(25px) rotate(45deg);
  -ms-transform: translateY(25px) rotate(45deg);
  -o-transform: translateY(25px) rotate(45deg);
  transform: translateY(7px) rotate(45deg);
}

#hamburger-1[aria-expanded="true"] .line:nth-child(2) {
  -webkit-transform: translateY(-13px) rotate(-45deg);
  -ms-transform: translateY(-13px) rotate(-45deg);
  -o-transform: translateY(-13px) rotate(-45deg);
  transform: translateY(-5px) rotate(-45deg);
}

#hamburger-1 {
  padding-right: 1rem;
}
</style>